import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { ColorsContextProvider } from "./context/colors.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    return <ColorsContextProvider>{children}</ColorsContextProvider>;
};

export { Base };
